import { takeLatest, all, fork, call, put } from 'redux-saga/effects';
import Actions from 'actions';
import api from 'api';

function* fetchCreatedEvent({ id, callbacks }) {
  try {
    const response = yield call(api.fetchCreatedEvent, id);
    yield put(Actions.fetchCreatedEventSuccess(response.data));
    if (typeof callbacks?.success === 'function') {
      yield call(callbacks.success);
    }
  } catch (error) {
    yield put(Actions.fetchCreatedEventFail(error));
    if (typeof callbacks?.failure === 'function') {
      const err = error?.response?.data?.error;
      yield call(callbacks.failure, err ? err[0] : error);
    }
  }
}

function* watchFetchCreatedEvent() {
  yield takeLatest(Actions.FETCH_CREATED_EVENT_REQUEST, fetchCreatedEvent);
}

export default function* create() {
  yield all([fork(watchFetchCreatedEvent)]);
}
